/**
 * 本地儲存鍵名常數
 * 集中管理所有應用程式使用的儲存鍵名
 */

export const STORAGE_KEYS = {
  // 側邊欄相關
  SIDEBAR_OPEN: "sidebar-open",

  // 使用者相關
  AUTH_TOKEN: "authToken",
  USER_PREFERENCES: "user-preferences",
  USER_CONTEXT: "user-context",

  // 專案相關
  CURRENT_PROJECT_ID: "current-project-id",
  CURRENT_PAGE_ID: "current-page-id",

  // 聊天相關
  CHAT_PAGE_ID: "chat-page-id",
  CHAT_PROJECT_ID: "chat-project-id",

  // 主題相關
  THEME_MODE: "theme-mode",

  // 語言相關
  LANGUAGE: "language",
};
